import { Stack, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { SlideDefinition } from './types'

type PlaceholderSlideProps = {
  slide: SlideDefinition
}

const PlaceholderSlide = ({ slide }: PlaceholderSlideProps) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        background: slide.background,
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 4,
      }}
    >
      <Stack spacing={1.5} maxWidth="720px" textAlign="center">
        <Typography variant="garage_h2">{slide.title}</Typography>
        <Typography variant="inter_bodyText">{slide.description}</Typography>
      </Stack>
    </Box>
  )
}

export default PlaceholderSlide
